import React from 'react';

const NAV_ITEMS = [
  { id: 'home', label: 'Home' },
  { id: 'history', label: 'History' },
  { id: 'deities', label: 'Deities' },
  { id: 'stotras', label: 'Stotras' },
  { id: 'mahotsavam', label: 'Mahotsavam' },
  { id: 'navathy', label: 'Navathy 2018' },
  { id: 'donations', label: 'Sevas & Donation' },
  { id: 'committee', label: 'Committee' },
];

const DesktopNav = ({ scrollToSection }) => (
  <nav className="hidden lg:flex space-x-4">
    {NAV_ITEMS.map((item) => (
      <button
        key={item.id}
        onClick={() => scrollToSection(item.id)}
        className="text-gray-700 hover:text-saffron font-medium transition-colors text-sm"
      >
        {item.label}
      </button>
    ))}
  </nav>
);

const MOBILE_LABELS = {
  stotras: 'Stotras and Bhajans',
  navathy: 'Navathy Mahotsav 2018',
  donations: 'Sevas and Donation',
  committee: 'Temple Committee',
};

const MobileNav = ({ scrollToSection }) => (
  <div className="lg:hidden pb-4">
    <div className="flex flex-col space-y-2">
      {NAV_ITEMS.map((item) => (
        <button
          key={item.id}
          onClick={() => scrollToSection(item.id)}
          className="bg-white text-gray-700 px-4 py-2 rounded-full font-medium transition-all hover:text-saffron hover:shadow-lg text-left border border-gray-200"
        >
          {MOBILE_LABELS[item.id] || item.label}
        </button>
      ))}
    </div>
  </div>
);

export { DesktopNav, MobileNav };
